const PRESERVE_WINDOW_MS = 3000;

let preserveBottomDetailUntil = 0;

export function preserveBottomDetailForNextSearch(): void {
  preserveBottomDetailUntil = Date.now() + PRESERVE_WINDOW_MS;
}

export function shouldPreserveBottomDetail(): boolean {
  return Date.now() < preserveBottomDetailUntil;
}

export function clearBottomDetailPreservation(): void {
  preserveBottomDetailUntil = 0;
}
